import React from "react";
import Layout from "../components/layout";

const Error = () => {
  return (
    <div>
      <Layout>
        <h1 className="px-4 py-4 rounded text-red-800 bg-red-200 text-xl font-bold text-center">
          Page not found!
        </h1>
      </Layout>
    </div>
  );
};

export default Error;
